'use client';

import { Anchor } from '@mantine/core';
import { setLocale } from '@website/server/actions/locale';

export function LangButton({ locale }: { locale: string }) {
  return (
    <Anchor c="gray.7" onClick={() => setLocale(locale === 'ar' ? 'en' : 'ar')}>
      {locale === 'ar' ? 'English' : 'العربية'}
    </Anchor>
  );
}
